<template lang="html">
  <div
    :class="categoryColor"
    class="teaser-tile-content"
  >
    <div class="teaser-tile-content__wrapper">
      <div class="teaser-tile-content__headline">
        <Headline
          :size="3"
          color="black"
          desktop-fluid
        >
          <span
            v-editable.text="resource.columns.title"
          />
        </Headline>
      </div>
      <Wysiwyg>
        <div
          v-editable="resource.columns.paragraph"
          class="teaser-tile-content__paragraph"
        />
      </Wysiwyg>
      <div>
        <nuxt-link
          v-if="linkedPage && linkedPage.url"
          class="teaser-tile-content__link"
          :to="linkedPage.url"
        >
          {{ resource.columns.link_name }}
        </nuxt-link>
        <span v-else class="teaser-tile-content__link" v-html="resource.columns.link_name" />
      </div>
    </div>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'

export default {
  components: {
    Headline,
    Wysiwyg
  },
  mixins: [ editable ],
  computed: {
    categoryColor () {
      const category = (this.resource.columns.category === undefined) ? 'neutral' : this.resource.columns.category
      return `teaser-tile-content--${category}`
    },
    linkedPage () {
      return Resource.query().where('id', this.resource.columns.link_to_page).first()
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/line-heights';

  $max-height: #{$max-width * 0.5};

  $component: '.teaser-tile-content';

  #{$component} {
    position: relative;
    @include font(0.5);
    line-height: line-height(3);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100vw;
    height: 0;
    padding-top: 100%;
    overflow: hidden;

    @include from(3) {
      width: 100%;
      padding-top: 75%;
    }

    @include from(4) {
      width: 50%;
      padding-top: 50%;
      max-height: $max-width * 0.5;
      max-width: $max-width * 0.5;
    }

    @include from(5) {
      @include font(1);
    }

    &--education {
      background-color: brand(3);
    }
    &--health {
      background-color: brand(4);
    }
    &--culture {
      background-color: brand(1);
    }
    &--sport {
      background-color: brand(2);
    }
    &--holding {
      background-color: brand(5);
    }
    &--neutral {
      background-color: brand(5);
      &:nth-child(odd) {
        background-color: gray(4);
      }

      &:nth-child(even) {
        background-color: gray(3);
      }
    }

    &__wrapper {
      @include grid-spacing(padding, 2);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    &__headline {
      margin-bottom: auto;

      a {
        transition: color 100ms ease-in-out, border-bottom-color 100ms ease-in-out;
      }

      a:hover {
        color: gray(2);
        border-bottom-color: gray(2);
      }
    }

    &__paragraph {
      margin-top: auto;
      margin-bottom: scale(1);
    }

    &__link {
      position: relative;
      overflow: hidden;
      transition: color 100ms ease-in-out;

      &:hover {
        color: gray(2);
      }

      &::before {
        position: absolute;
        width: 100%;
        height: 1px;
        left: 0;
        bottom: 0;
        content: '';
        background-color: gray(1);
        transform-origin: center center;
        animation-name: linkOutAnimation;
        animation-duration: 300ms;
        animation-timing-function: ease-in-out;
        pointer-events: none;
      }

      &:hover::before, &:focus::before {
        background-color: gray(2);
        animation-name: linkOverAnimation;
        animation-duration: 300ms;
        animation-timing-function: ease-in-out;
      }
    }

    @keyframes linkOutAnimation {
      from {
        transform: scaleX(0);
      }
      to {
        transform: scaleX(1);
      }
    }

    @keyframes linkOverAnimation {
      from {
        transform: scaleX(0);
      }
      to {
        transform: scaleX(1);
      }
    }
  }
</style>
